import React from "react";
import UnifiedFormComponent from "./components/UnifiedFormComponent";

const LaporanNVR = () => {
  const handleSuccess = (result) => {
    console.log('NVR data saved successfully:', result);
  };

  const handleError = (error) => {
    console.error('Error saving NVR data:', error);
  };

  return (
    <UnifiedFormComponent 
      formType="nvr"
      onSuccess={handleSuccess}
      onError={handleError}
    />
  );
};

export default LaporanNVR;
